// extracted by mini-css-extract-plugin
export var copy = "CenteredTextOverlay-module--copy--6e4bc";
export var desktop = "CenteredTextOverlay-module--desktop--7043f";
export var eyebrow = "CenteredTextOverlay-module--eyebrow--6cc12";
export var image = "CenteredTextOverlay-module--image--e3ffa";
export var mobile = "CenteredTextOverlay-module--mobile--d9bcf";
export var section = "CenteredTextOverlay-module--section--ae888";